import React from 'react';
import PropTypes from 'prop-types';
import { Box, SnackbarContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { resolveApiErrorMessage } from 'utils';

const useStyles = makeStyles(theme => ({
  errorMessage: {
    backgroundColor: theme.palette.error.main,
    paddingTop: '3px',
    paddingBottom: '3px',
  },
}));

const SubmitErrorMessage = ({ message, translationFile }) => {
  const classes = useStyles();
  const { t } = useTranslation(translationFile);

  const messageTranslate = resolveApiErrorMessage(message, { t, fallbackMessage: t('errors.serverError') });

  return (
    <Box mt={3}>
      <SnackbarContent classes={{ root: classes.errorMessage }} message={messageTranslate} />
    </Box>
  );
};

SubmitErrorMessage.defaultProps = {
  translationFile: 'common',
};

SubmitErrorMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  translationFile: PropTypes.string,
};

export default SubmitErrorMessage;
